export const NewProgramAddedGroupStepController = [
    '$scope', '$http', '$location', 'RegistrationService',
    function($scope, $http, $location, RegistrationService) {
        $scope.groupName = 'All done!';
        $scope.hideNav = false;
        $scope.withHero = false;
        $scope.autoAdvance = true;
        $scope.finalStep = 1;
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/newProgramAdded.html';

        $scope.goToPreviousStep = function() {
            $location.path('/personal_info/1');
        };

        $scope.complete = function() {
            RegistrationService.registrationComplete();
        }
    },
];
